import { useRef } from "react";

// /* inputやbuttonタグに渡せる属性の一覧 */
// type NativeInputProps = React.InputHTMLAttributes<HTMLInputElement>;
// type NativeButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * - input自体は常に非表示にするためstyleは指定不可とする
 * - refはボタンと紐付けるために使用するため指定不可する
 * - typeは`file`のみを受け付ける
 */
// type InputProps = Omit<NativeInputProps, 'type' | 'style' | 'ref'> & { type: 'file' };

/**
 * - onClickはinputを発火するために使用するため指定不可とする
 */
// type ButtonProps = Omit<NativeButtonProps, 'onClick'>;

// type ButtonWithInputFileProps = ButtonProps & { inputProps: InputProps };

export const ButtonWithInputFile = ({
  children,
  inputProps,
  ...buttonProps
}) => {
  const fileInputRef = useRef(null);

  return (
    <>
      <button
        type="button"
        className="
          inline-flex
          h-10
          w-10
          items-center
          justify-center
          rounded-lg
          bg-twitter
          px-0
          py-2
          text-xs
          font-medium
          text-white
          hover:bg-sky-400
          active:bg-twitter
          dark:bg-twitter
          dark:hover:bg-sky-300
          dark:focus:ring-gray-800
          sm:w-32
          sm:px-4
        "
        style={{ WebkitAppearance: "none", appearance: "none" }}
        {...buttonProps}
        onClick={() => fileInputRef.current?.click()}
      >
        {children}
      </button>
      <input
        type="file"
        accept="image/*"
        multiple
        {...inputProps}
        ref={fileInputRef}
        style={{ display: "none" }}
      />
    </>
  );
};
